import List from './list/ReferralNetworkDetailsListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})